import { GridColDef } from "@mui/x-data-grid";
import { getCommonColumns, CommonDeps } from "./columnsCommon";
import { Tooltip } from "@mui/material";

export const getTaxColumns = (
  deps: CommonDeps & { getActionButtons: any }
): GridColDef[] => {
  const { getActionButtons } = deps;
  const emitenteColumn: GridColDef = {
    field: "emitente",
    headerClassName: "header-table",
    renderHeader: () => <b className="emitenteColluns">Emitente</b>,
    flex: 0.6,
    headerAlign: "left",
    align: "left",
    renderCell: (params) => {
      const value = params.row.emitter ?? "";
      return value.length > 10 ? (
        <Tooltip title={value}>
          <div
            style={{
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {value.slice(0, 12) + "..."}
          </div>
        </Tooltip>
      ) : (
        <div
          style={{
            width: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {value}
        </div>
      );
    },
  };

  const flagColumn: GridColDef = {
    field: "flag",
    headerClassName: "header-table",
    renderHeader: () => <b className="flagColluns">Flag</b>,
    flex: 0.6,
    headerAlign: "left",
    align: "left",
    renderCell: (params) =>
      params.row.flag ? (
        <span>{params.row.flag}</span>
      ) : (
        <div className="centerText">N/A</div>
      ),
  };

  const statusTaxColumn: GridColDef = {
    field: "status",
    headerClassName: "header-table",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
    renderHeader: () => (
      <div className="descriptionText">
        <b className="title-table"> Status </b>
      </div>
    ),
    renderCell: (params) => {
      const status = params.row.status;
      const tooltipMap: Record<string, string> = {
        ENTREGUE_SAP: "Entregue SAP",
        EM_CLASSIFICACAO: "Em classificação",
        PENDENTE_VALIDACAO_FISCAL: "Pendente de Validação Fiscal",
        EM_ANALISE: "Em Análise",
        RECLASSIFICADO: "Reclassificado",
        FINALIZADO: "Processo Finalizado",
        PENDENTE_GRUPO: "Pendente de Grupo",
      };
      return (
        <Tooltip title={tooltipMap[status] || ""}>
          <div className="status-forecast-text">
            <div className={`status-forecast ${status?.toLowerCase()}`}></div>
          </div>
        </Tooltip>
      );
    },
  };

  const actionsColumn: GridColDef = {
    field: "ações",
    flex: 0.4,
    headerAlign: "left",
    align: "left",
    renderHeader: () => <b className="title-table">Ações</b>,
    renderCell: (params) => {
      const buttons = getActionButtons(params.row.status, params.row);
      return (
        <div
          style={{
            display: "flex",
            width: "100%",
            paddingTop: "15px",
            justifyContent: "start",
            flexWrap: "nowrap",
            overflowX: "auto",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>{buttons}</div>
        </div>
      );
    },
    headerClassName: "header-table",
  };

  return [
    ...getCommonColumns(deps),
    emitenteColumn,
    flagColumn,
    statusTaxColumn,
    actionsColumn,
  ];
};
